
import '../App.css';
import { useParams, useNavigate} from 'react-router-dom';
import { Component } from 'react';
import EnvironmentService from "../service/environmentService";
import { Link } from "react-router-dom";
import ShowService from '../service/showService';

function withParams(Component) {
  return props => <Component {...props} params={useParams()} Navigate={useNavigate()} />;
}


class ShowsSeasonEpisodes extends Component {
    // var movies = [];



  constructor(props){
    super(props);

    this.environmentService = new EnvironmentService();
    this.ShowService = new ShowService();

    this.state = {
      episodes : []
    }
  }

  componentDidMount(){

    this.getMovies();
  }

  async getMovies(){
    var result = await this.ShowService.GetSeasonEpisodes(this.props.params.uuid)
   this.setState({
    episodes : result
   })

  }

  render(){
    const episodes = this.state.episodes;
    if(!episodes) return null;


    return(
       <div>
        <Link to={"/shows"}>Back</Link>
          <div>
            <text class="page-title">Episodes</text>
          </div>
          <div class="grid-container">
            {episodes.map((episode) =>(
              <div class="grid-item" key={episode.uuid}>
                <a href={this.environmentService.getFrontEndEnvironmentHost() + '/shows/episode/overview/' + episode.uuid} className='link-hidden'>
                  <div>
                    <text> 
                        {episode.name}<br/>
                    </text>
                  </div>
                </a>
              </div>
            ))
          }
          </div>
       </div> 
      )
  }
}

export default withParams(ShowsSeasonEpisodes);
